import React, { Component } from "react";
import MainLayout from '../../mainLayout';
import { Link } from 'react-router-dom'

//Validation import 
import SimpleReactValidator from 'simple-react-validator';

//Service import 
import service from '../../services'

//moment import 
import moment from 'moment'

//react-paginate import 
import ReactPaginate from "react-paginate";

//Connect Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { ActCreators } from '../../redux/bindActionCretor'

//Loader import
import Loader from "../loader";

//sweet alert
import swal from 'sweetalert';

//import AWS from "aws-sdk";
import AWS from "aws-sdk";

// Images import
import serachIcon from "../../assets/images/search.svg";
import edit from "../../assets/images/edit.svg";
import lock from "../../assets/images/lock.svg";
import lockIcon from "../../assets/images/lock-icon.svg";
import delet from "../../assets/images/delet.svg";
import share from "../../assets/images/share.svg";
import hoverIcon from "../../assets/images/hover-popup.svg";
import hoverIconActive from "../../assets/images/hover-popup-active.svg";
import close from "../../assets/images/close.svg";
import cloud from "../../assets/images/cloud.svg";
import plusIcon from "../../assets/images/plusIcon.svg";
import background from "../../assets/images/background.jpg";
import CheckBox from "../CheckBox";
import ErrorPopUp from "../errorPopUp";
import DeletefileIcon from "../../icons/DeletefileIcon";
import PopUpCustomAll from "../fpg/create/popUpCustomAll";
import EditIcon from '../../icons/EditIcon';
import LockIcon from '../../icons/LockIcon';
import LockCloseIcon from '../../icons/LockCloseIcon';
import DeleteIcon from '../../icons/DeleteIcon';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import commonImage from "../../commonImage";
let sub;

// fake data generator
const getItems = count =>
    Array.from({ length: count }, (v, k) => k).map(k => ({
        id: `item-${k}`,
        content: `item ${k}`
    })
    );

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
const mapStateToProps = state => ({
    getPartnerDetails: state.getPartnerDetails,
    getLoginRole: state.getLoginRole
})

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch)
};

class satellitesViewEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userForResendMail: [],
            emailLoader: false,
            resendMailPopup: false,
            email: '',
            contactFullName: '',
            lastName: '',
            partnerSubTitle: '',
            getAllSatelliteDetails: [],
            getAllSatellitesdocs: [],
            createSatellitePopup: false,
            changeTitleName: false,
            errorPopup: false,
            selectedDropdown: '',
            file: null,
            loaderFlag: false,
            instituteAssociate: false,
            disPartnerType: {
                All: true,
                general_sponsor: false,
                presenting_sponsor: false,
                media_sponsor: false,
                sustaining_sponsor: false,
                leadership_sponsor: false
            },
            partnerDispalyType: [
                { name: "All", value: true, pass: 'true' },
                { name: "Yes", value: false, pass: 'true' },
                // {name:"Presenting Sponsor",value:false},
                // {name:"Media Sponsor",value:false},
                // {name:"Sustaining Sponsor",value:false},
                // {name:"Leadership Sponsor",value:false},
            ],

            id: '',
            searchField: '',
            imagePreloader: false,
            partnerTypeList: [
                { value: 'Select an Option', name: 'Select an Option' },
                { value: 'General Sponsor', name: 'General Sponsor' },
                { value: 'Presenting Sponsor', name: 'Presenting Sponsor' },
                { value: 'Sustaining Sponsor', name: 'Sustaining Sponsor' },
                { value: 'Media Sponsor', name: 'Media Sponsor' },
                { value: 'Leadership Sponsor', name: 'Leadership Sponsor' }
            ],
            // pagination variable diclaration start
            offset: 0,
            perPage: 9999,
            currentPage: 1,
            // pagination variable diclaration end
        };
        this.validator = new SimpleReactValidator({
            autoForceUpdate: this,
            validators: {
                apostrophe: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z ']*)$/i) || validator.helpers.testRegex(val, /^[-a-zA-Z s]+$/i) && params.indexOf(val) === -1
                    },
                    required: true  // optional
                },
                companyName: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 . : , _']*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                },
                companyName1: {  // name the rule
                    message: 'Please use a valid name of the :attribute',
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val, /^([-a-zA-Z0-9 . : , _ + @ & | ( )']*)$/i) && params.indexOf(val) === -1
                    },
                    required: false  // optional
                }
            }
        });
        this.apiserve = new service();
        this.onDragEnd = this.onDragEnd.bind(this)
    }

    componentDidMount = async () => {
        this.getAllSatelliteView(this.state.offset, this.state.perPage);
        this.getAllSatelliteSreen();
        this.setState({
            loaderFlag: true,
        });
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
    }

    getAllSatelliteSreen = () => {
        sub = this.apiserve.getevent().subscribe((response) => {
            switch (response.event) {
                case "FestivalVillage|SatelliteScreen|getList":
                    this.setState({
                        getAllSatelliteDetails: response.data,
                        getAllSatellitesdocs: response.data.docs
                    }, () => {
                        this.setState({
                            loaderFlag: false,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                        })
                    })
                    break;
                case "FestivalVillage|SatelliteScreen|create":
                    if (response.error) {
                        this.setState({
                            loaderFlag: false,
                            // errorPopup: true,
                            // errorMsg: response.data.error ? response.data.error : response.data
                        })
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    } else {
                        this.setState({
                            createSatellitePopup: false
                        }, () => this.getAllSatelliteView(this.state.offset, this.state.perPage),
                            this.setState({
                                loaderFlag: false,
                                isBlocked: false,
                                contactFullName: '',
                                city: '',
                                state: '',
                                satelliteScreenName: '',
                                email: '',
                                role: '',
                            }),
                            this.apiserve.success('Community Hub Partner created successful.'))
                    }

                    break;
                case "FestivalVillage|SatelliteScreen|remove":

                    if (response.error) {
                    } else {
                        this.getAllSatelliteView(this.state.offset, this.state.perPage);
                    }
                    break;
                case "FestivalVillage|blockUser":
                    this.getAllSatelliteView(this.state.offset, this.state.perPage);
                    break;
                case "FestivalVillage|SatelliteScreen|edit":
                    if (response.error === true) {
                        this.setState({
                            loaderFlag: false
                        })
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    } else {
                        this.setState({
                            createSatellitePopup: false
                        }, () => this.getAllSatelliteView(this.state.offset, this.state.perPage),
                            this.setState({
                                loaderFlag: false,
                                isBlocked: false,
                                contactFullName: '',
                                city: '',
                                state: '',
                                satelliteScreenName: '',
                                email: '',
                            }),
                            this.apiserve.success('Community Hub Partner updated successful.'))
                    }
                    break;
                case "loginUser":
                    if (response.error) {
                        this.apiserve.error(response.data)
                    } else {
                        let data = response.data;
                        const newRole = data.userData.additionalRoles.filter(role => role !== "generalUser")[0];
                        data.user.role = newRole;
                        this.props.LoginRole(data)
                        this.props.BackToAdminFlag(true)
                        localStorage.setItem('loginToken', response.data.token)
                        localStorage.setItem('currentUserRole', data.user.role)
                        this.apiserve.sendevent("getUser", { id: response.data.user._id });
                    }
                    break;
                case "getUser":
                    this.props.ProfileName(response.data)
                    if (response.data.role === "satellite") {
                        this.props.GetSatellite(response.data)
                        this.props.history.push('/profile-satellite-view')
                    }
                    break;
                case "FestivalVillage|getUserCsv":
                    if (!response.error) {
                        window.open(response.data.location)
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                case "FestivalVillage|sendMail":
                    if (!response.error) {
                        this.apiserve.success('Email sent!')
                        this.setState({
                            resendMailPopup: false,
                            emailLoader: false,
                            userForResendMail: []
                        })
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                case "FestivalVillage|changeOrder":
                    if (!response.error) {
                        this.getAllSatelliteView(this.state.offset, this.state.perPage)
                    }
                    else {
                        this.apiserve.error(response.data.error)
                    }
                    break;

            }
        });
    }

    getAllSatelliteView = (skip, limit) => {
        const { getLoginRole } = this.props
        if (getLoginRole.user.role === 'admin') {
            var data = {
                // role: "partner",
                page: skip,
                limit: limit
            }
            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
        } else {
            var data = {
                // role: "partner",
                addedBy: getLoginRole.user._id,
                page: skip,
                limit: limit
            }
            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
        }

        this.apiserve.sendevent("FestivalVillage|SatelliteScreen|getList", data);
    }

    createPartnersUser = async () => {
        this.setState({
            createSatellitePopup: true,
            changeTitleName: false,
            contactFullName: '',
            satelliteScreenThumbnail: '',
            satelliteLogo: '',
            satelliteScreenName: '',
            lastName: "",
            city: "",
            state: "",
            email: ""
        })
        this.validator.hideMessages();

    }

    closePartnerUser = () => {
        this.setState({
            createSatellitePopup: false,
            changeTitleName: false,
            satelliteScreenThumbnail: '',
            satelliteLogo: '',
            satelliteScreenName: '',
            contactFullName: "",
            lastName: "",
            city: "",
            state: "",
            resendMailPopup: false,
        })
        this.validator.hideMessages();
    }

    onInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    onInputChangeDropDown = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            selectedDropdown: e.target.value
        });
    }

    submitFn = async (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({ loaderFlag: true })
            let data = {
                satelliteScreenThumbnail: this.state.satelliteScreenThumbnail ? this.state.satelliteScreenThumbnail : '',
                satelliteLogo: this.state.satelliteLogo ? this.state.satelliteLogo : '',
                satelliteScreenName: this.state.satelliteScreenName,
                email: this.state.email,
                contactFullName: this.state.contactFullName,
                // city: this.state.city,
                // state: this.state.state
            }
            if (this.state.changeTitleName) data.id = this.state.id
            this.apiserve.sendevent(this.state.changeTitleName ? "FestivalVillage|SatelliteScreen|edit" : "FestivalVillage|SatelliteScreen|create", data);
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    editSatellitesScreen = async (item) => {

        this.setState({
            id: item._id,
            createSatellitePopup: true,
            changeTitleName: true,
            satelliteScreenThumbnail: item.satelliteScreenThumbnail,
            satelliteLogo: item.satelliteLogo,
            // satelliteScreenThumbnailUrl: item.satelliteScreenThumbnailUrl ? item.satelliteScreenThumbnailUrl : '',
            satelliteScreenName: item.satelliteScreenName,
            email: item.email,
            contactFullName: item.contactFullName,
            city: item.city,
            state: item.state
        })
    }

    deletePartnersUser = async (item) => {

        swal({
            title: "Are you sure?",
            text: "You want to delete this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willDelete) => {
                if (willDelete) {
                    swal("Your record has been deleted!", {
                        icon: "success"
                    });
                    let data = {
                        id: item._id
                    }
                    this.apiserve.sendevent("FestivalVillage|SatelliteScreen|remove", data);
                } else {
                    swal("Your record is safe!");
                }
            });


    }

    blockPartnersUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to block this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willBlock) => {
                if (willBlock) {
                    swal("Your record has been block!", {
                        icon: "success"
                    });
                    let data = {
                        userId: item._id,
                        role: "satellite",
                        isBlocked: true
                    }
                    this.apiserve.sendevent("FestivalVillage|blockUser", data);
                } else {
                    swal("Your record is unblock!");
                }
            });
    }

    unblockPartnersUser = async (item) => {
        swal({
            title: "Are you sure?",
            text: "You want to unblock this record",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        })
            .then((willBlock) => {
                if (willBlock) {
                    swal("Your record has been unblock!", {
                        icon: "success"
                    });
                    let data = {
                        userId: item._id,
                        role: "satellite",
                        isBlocked: false
                    }
                    this.apiserve.sendevent("FestivalVillage|blockUser", data);
                } else {
                    swal("Your record is block!");
                }
            });
    }

    changeRouteUser = (item) => {
        let data = {
            id: item._id
        }
        this.props.LoginUser(this.props.getLoginRole);
        this.apiserve.sendevent("loginUser", data);
    }

    onChangeFileSatelliteLogo(e) {
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            this.setState({
                file: file,
            }, () => {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        this.imageUploadSatelliteLogo(file,event.target.result);
                    }, 0)
                } else {
                    this.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            });
        }
    }

    imageUploadSatelliteLogo = (file, img) => {
        this.setState({ imagePreloader1: true })

        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value) => {
                this.setState({
                    satelliteLogo: value,
                    imagePreloader1: false
                });
            });
    };


    onChangeFile(e) {
        var self = this;
        e.stopPropagation()
        e.preventDefault();
        let file = e.target.files[0];
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onloadend = (event) => {
            self.setState({
                file: file,
                // satelliteScreenThumbnail: reader.result
            }, () => {
                const fileList = Math.round((file && file.size / 1024));
                if (fileList >= 2048) {
                    self.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file smaller than 2 MB'
                    })
                    return false;
                }
                if (file && file.type === 'image/png' || file && file.type === 'image/jpg' || file && file.type === 'image/jpeg') {
                    setTimeout(() => {
                        self.imageUpload(file,event.target.result);
                    }, 0)
                } else {
                    self.setState({
                        errorPopup: true,
                        errorMsg: 'Please upload a file for PNG,JPG or JPEG'
                    })
                }
            });
        }
    }

    imageUpload = (file, img) => {
        this.setState({ imagePreloader: true })
        var fileSet = commonImage(file,false,'',img)
        fileSet.then((value)=> {
                this.setState({
                    imagePreloader: false,
                    satelliteScreenThumbnail: value,
                });
            });
    };

    //Pagination Click
    // handlePageClick = (e) => {
    //     const selectedPage = e.selected;
    //     const offset = selectedPage + 1;
    //     this.setState(
    //         {
    //             currentPage: selectedPage,
    //             offset: offset,
    //             loaderFlag: true
    //         },
    //         () => {
    //             this.getAllSatelliteView(offset, this.state.perPage);
    //         }
    //     );
    // };

    getPartnarTypeDetails = (skip, limit) => {
        this.setState({ loaderFlag: true })
        const partnerTypeDetails = {
            page: skip,
            limit: limit
        }
        this.apiserve.sendevent("FestivalVillage|SatelliteScreen|getList", partnerTypeDetails);
    }
    //displayPartnerType Wise Filter end

    getPartnerTableHeadView = () => {
        const { partnerDispalyType } = this.state
        return (
            <tr>
                <th className="partnerName_d">Community Hub Partner Name</th>
                <th className="firstName_d" style={{ width: "220px" }}>Contact Full Name</th>
                <th className="lastName_d" style={{ width: "270px" }}>Contact Email</th>
                {/* <th className="email_d" style={{ width: "200px" }}>Location</th> */}
                <th className="regOn_d" style={{ width: "145px" }}>Last Logged On</th>
                <th className="addOn_d" style={{ width: "145px" }}>Added On</th>
                <th className="icon_d" style={{ width: "175px" }}></th>
            </tr>
        )
    }

    sendEmailPopup = (user) => {
        this.setState({
            userForResendMail: user,
            userContactFullName: user.contactFullName
        }, () => {
            this.setState({
                resendMailPopup: true
            })
        })
    }

    resendMail = () => {
        var data = {
            id: this.state.userForResendMail._id
        }
        this.setState({
            emailLoader: true
        })
        this.apiserve.sendevent("FestivalVillage|sendMail", data)
    }

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
            return;
        }
        const { getAllSatellitesdocs } = this.state
        const { destination, source } = result;
        const oldIndex = source.index;
        const newIndex = destination.index;
        const arr = [...this.state.getAllSatellitesdocs];
        if (newIndex >= arr.length) {
            var k = newIndex - arr.length + 1;
            while (k--) {
                arr.push(undefined);
            }
        }
        arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
        const updateArr = [];
        arr.forEach(({ _id }, i) => {
            updateArr.push({
                userId: _id,
                sortIndex: i + 1,
            });
        });
        this.setState({ isDraggable: true });
        const data = { order: updateArr };
        this.apiserve.sendevent('FestivalVillage|changeOrder', data)
        this.setState({ getAllSatellitesdocs: arr });
    }

    //Search Data
    onSearchFilter = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        }, () => {
            var data = {
                page: 1,
                limit: 9999
            }
            if (this.state.searchField.length) {
                data = {
                    filter: this.state.searchField,
                }
            }
            this.apiserve.sendevent("FestivalVillage|SatelliteScreen|getList", data);
        });
    }

    clearFn = () => {
        this.setState({
            satelliteScreenThumbnail: '',
            satelliteLogo: '',
            satelliteScreenName: '',
            contactFullName: "",
            lastName: "",
            city: "",
            state: "",
        })
        if (this.state.changeTitleName !== true) this.setState({ email: "" })
    }

    handleUncheck = (e) => {
        const { name, value, checked } = e.target;
        this.setState({
            [name]: checked
        })
    }

    validateModel = () => {
        this.setState({
            errorPopup: false,
        });
    };

    deleteImagePopup = () => {
        if (this.state.isLogo) {
            this.setState({
                satelliteLogo: '',
                deleteImagePopup: false
            })
        } else {
            this.setState({
                satelliteScreenThumbnail: '',
                deleteImagePopup: false,
            })
        }

    }

    deleteImage(e) {
        this.setState({
            isLogo: e,
            deleteImagePopup: true,
        })
    }

    closeAdminUser = () => {
        this.setState({
            deleteImagePopup: false
        });
    };

    downloadcsv = () => {
        var data = {
            role: 'satellite'
        }
        this.apiserve.sendevent("FestivalVillage|getUserCsv", data);
    }

    render() {
        const { createSatellitePopup, getAllSatelliteDetails, getAllSatellitesdocs, changeTitleName } = this.state
        return (
            <React.Fragment>
                <div className="right_side_wrapper partnerView_wrapper adminDashboard_wrapper">
                    <div className="dashboard_header with_btn">
                        <div className="searchBlock">
                            {/* <span>All Users ( {getAllSatelliteDetails.totalDocs} )</span> */}
                            <span>Community Hub ( {getAllSatelliteDetails.totalDocs} )</span>
                            <form onSubmit={e => { e.preventDefault(); }}>
                                <input
                                    type="text"
                                    placeholder="Search"
                                    id="searchField"
                                    name="searchField"
                                    value={this.state.searchField}
                                    onChange={this.onSearchFilter}
                                    autoComplete="off"
                                />
                                <button type="submit" style={{ pointerEvents: 'none' }}>
                                    <img src={serachIcon} />
                                </button>
                            </form>
                        </div>
                        <div className="button_block admin_user_twoBtn">
                            <div className="icon_block">
                                <Link onClick={() => this.downloadcsv()}><img src={cloud} /></Link>
                            </div>
                            <Link className="head_btn text_center"
                                onClick={() => this.createPartnersUser()}>
                                Add Community Hub Partner
                            </Link>
                        </div>
                    </div>
                    <div className="dashboard_data">
                        <div className="dashboard_data_table">
                            <table>
                                <thead>
                                    {this.getPartnerTableHeadView()}
                                </thead>
                                <DragDropContext onDragEnd={this.onDragEnd}>
                                    <Droppable droppableId="droppable">
                                        {(provided, snapshot) => (
                                            <tbody {...provided.droppableProps} ref={provided.innerRef} >
                                                {getAllSatellitesdocs.map((item, index) => {
                                                    return (
                                                        <Draggable
                                                            key={item._id}
                                                            draggableId={`'${item._id}'`}
                                                            index={index}
                                                        >
                                                            {(provided, snapshot) => (
                                                                <tr ref={provided.innerRef}
                                                                    {...provided.draggableProps}
                                                                    {...provided.dragHandleProps}>
                                                                    <>
                                                                    <td className="user_email_d partnerName_d "> <span className="user_status">
                                                                        <svg className="active" xmlns="http://www.w3.org/2000/svg" width="8" height="8" fill="none" viewBox="0 0 8 8"><circle cx="1" cy="1" r="1" fill="#666"></circle><circle cx="1" cy="4" r="1" fill="#666"></circle><circle cx="1" cy="7" r="1" fill="#666"></circle><circle cx="4" cy="1" r="1" fill="#666"></circle><circle cx="4" cy="4" r="1" fill="#666"></circle><circle cx="4" cy="7" r="1" fill="#666"></circle><circle cx="7" cy="1" r="1" fill="#666"></circle><circle cx="7" cy="4" r="1" fill="#666"></circle><circle cx="7" cy="7" r="1" fill="#666"></circle></svg>
                                                                    </span>{item.satelliteScreenName}</td>
                                                                    <td className="firstName_d" style={{ width: "220px" }}>{item.contactFullName}</td>
                                                                    <td className="lastName_d" style={{ width: "270px" }}>{item.email}</td>
                                                                    {/* <td className="lastName_d" style={{ width: "200px" }}>{item.city},{item.state}</td> */}
                                                                    <td className="regOn_d" style={{ width: "145px" }}>{item.lastLogin ? moment(item.lastLogin).format('MM/DD/YYYY') : "-"}</td>
                                                                    <td className="addOn_d" style={{ width: "145px" }}>{item.createdAt ? moment(item.createdAt).format('MM/DD/YYYY') : "-"}</td>
                                                                    <td className="p_0" style={{ width: "175px" }}>
                                                                        <div className="icon_d p_0 w_100">
                                                                            <Link onClick={() => this.editSatellitesScreen(item)}>
                                                                                <EditIcon />
                                                                                <div>edit</div>
                                                                            </Link>
                                                                            {item.isBlocked ?
                                                                                <Link onClick={() => this.unblockPartnersUser(item)}>
                                                                                    <LockIcon /> <div>lock</div>
                                                                                </Link>
                                                                                :
                                                                                <Link onClick={() => this.blockPartnersUser(item)}>
                                                                                    <LockCloseIcon /><div>unlock</div>
                                                                                </Link>
                                                                            }
                                                                            <Link onClick={() => this.deletePartnersUser(item)}>
                                                                                <DeleteIcon /><div>delete</div>
                                                                            </Link>
                                                                            <Link onClick={() => this.changeRouteUser(item)}>
                                                                                {/* <img src={share} /><div>share</div> */}
                                                                                <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                    <path d="M6.33203 8.66668L9.66536 6.00001L6.33203 3.33334V5.33334H0.332031V6.66668H6.33203V8.66668Z" fill="#5D737E" />
                                                                                    <path d="M7.66601 -0.000678997C6.87769 -0.00286479 6.09678 0.151395 5.3685 0.453163C4.64023 0.754932 3.97908 1.19821 3.42334 1.75732L4.36601 2.69999C5.24734 1.81865 6.41934 1.33265 7.66601 1.33265C8.91267 1.33265 10.0847 1.81865 10.966 2.69999C11.8473 3.58132 12.3333 4.75332 12.3333 5.99999C12.3333 7.24665 11.8473 8.41866 10.966 9.29999C10.0847 10.1813 8.91267 10.6673 7.66601 10.6673C6.41934 10.6673 5.24734 10.1813 4.36601 9.29999L3.42334 10.2427C4.55601 11.376 6.06267 12.0007 7.66601 12.0007C9.26934 12.0007 10.776 11.376 11.9087 10.2427C13.042 9.10999 13.6667 7.60332 13.6667 5.99999C13.6667 4.39665 13.042 2.88999 11.9087 1.75732C11.3529 1.19821 10.6918 0.754932 9.96351 0.453163C9.23524 0.151395 8.45432 -0.00286479 7.66601 -0.000678997Z" fill="#5D737E" />
                                                                                </svg>
                                                                                {/* <div>share</div> */}
                                                                            </Link>
                                                                            {item.verified ? '' :
                                                                                <Link className="check_admin" onClick={() => this.sendEmailPopup(item)}>
                                                                                    <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                        <path d="M11 13H15V10L20 14.5L15 19V16H11V13ZM18 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H9V14H2V4L10 9L18 4V10H20V2C20 1.46957 19.7893 0.960859 19.4142 0.585786C19.0391 0.210714 18.5304 0 18 0ZM10 7L2 2H18L10 7Z" fill="white" />
                                                                                    </svg>
                                                                                    <span className="tooltip_box">Send invitation email</span>
                                                                                </Link>
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                    </>
                                                                </tr>
                                                            )}
                                                        </Draggable>
                                                    )
                                                }
                                                )}
                                            </tbody>
                                        )}
                                    </Droppable>
                                </DragDropContext>
                            </table>
                        </div>

                        {/* {getAllSatellitesdocs.length && getAllSatellitesdocs ? (
                            <div className="custom-pagination">
                                <ReactPaginate
                                    previousLabel={""}
                                    nextLabel={""}
                                    breakLabel={"..."}
                                    breakClassName={"break-me"}
                                    pageCount={this.state.pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={this.handlePageClick}
                                    containerClassName={"pagination"}
                                    subContainerClassName={"pages pagination"}
                                    activeClassName={"active"}
                                />
                            </div>
                        ) : (
                                ""
                            )} */}

                    </div>
                    {createSatellitePopup ?
                        <div className="popup_wrapper partner-event-popup" style={{ maxWidth: "568px" }}>
                            <h2>
                                {changeTitleName ? " Edit Community Hub Partner" : "Create New Community Hub Partner "}
                                <img src={close} onClick={() => this.closePartnerUser()} />
                            </h2>
                            <form>
                                <div className="details">
                                    <div className="partnerLogo">
                                        <label> Partner Logo</label>
                                        <div className='image_pre_loader'>
                                            <input id="myInput"
                                                type="file"
                                                ref={(ref) => this.upload1 = ref}
                                                style={{ display: 'none' }}
                                                onChange={this.onChangeFileSatelliteLogo.bind(this)}
                                                accept=".png, .jpg, .jpeg"
                                            />
                                            {this.state.imagePreloader1 ?
                                                <Loader />
                                                :
                                                <img src={this.state.satelliteLogo
                                                    ? this.apiserve.imageUrl + this.state.satelliteLogo
                                                    : background
                                                } />
                                            }
                                            <a className={this.state.satelliteLogo ? "add_file_img active" : 'add_file_img'} onClick={() => { this.upload1.click() }} ><img src={plusIcon} /></a>
                                            {this.state.satelliteLogo ?
                                                <span className="remove_file pointer"
                                                    onClick={() => this.deleteImage(true)}
                                                ><DeletefileIcon /></span> : ''}
                                        </div>
                                    </div>

                                    <div className="partnerLogo mb_0 d_just_normal">
                                        <label>Partner Thumbnail</label>
                                        <div className='image_pre_loader'>
                                            <input id="myInput"
                                                type="file"
                                                ref={(ref) => this.upload = ref}
                                                style={{ display: 'none' }}
                                                onChange={this.onChangeFile.bind(this)}
                                                accept=".png, .jpg, .jpeg"
                                            />
                                            {this.state.imagePreloader ?
                                                <Loader />
                                                :
                                                <img src={this.state.satelliteScreenThumbnail
                                                    ? this.apiserve.imageUrl + this.state.satelliteScreenThumbnail
                                                    : background
                                                } />
                                            }
                                            <a className={this.state.satelliteScreenThumbnail ? "add_file_img active" : 'add_file_img'} onClick={() => { this.upload.click() }} ><img src={plusIcon} /></a>
                                            {this.state.satelliteScreenThumbnail ?
                                                <span className="remove_file pointer"
                                                    onClick={() => this.deleteImage(false)}
                                                ><DeletefileIcon /></span> : ''}
                                        </div>


                                    </div>
                                    <div className="form_group">
                                        <label>&nbsp;</label>
                                        <div className="form_group_input">
                                            <span style={{ color: 'red' }}>{
                                                this.validator.message(
                                                    'Partner Thumbnail',
                                                    this.state.satelliteScreenThumbnail
                                                        ? this.apiserve.imageUrl + this.state.satelliteScreenThumbnail
                                                        : this.state.satelliteScreenThumbnailUrl,
                                                    'required')}</span>
                                        </div>
                                    </div>
                                    <div className="form_group">
                                        <label> Partner Name</label>
                                        <div className="form_group_input">
                                            <input
                                                type="text"
                                                name="satelliteScreenName"
                                                id="satelliteScreenName"
                                                value={this.state.satelliteScreenName}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('Partner name', this.state.satelliteScreenName, 'required')}</span>
                                        </div>
                                    </div>
                                    <div className="form_group">
                                        <label>Contact Email</label>
                                        <div className="form_group_input">
                                            <input
                                                type="email"
                                                name="email"
                                                id="email"
                                                disabled={this.state.changeTitleName ? true : false}
                                                maxLength={255}
                                                value={this.state.email}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('email', this.state.email, 'required|email')}</span>
                                        </div>
                                    </div>
                                    <div className="form_group">
                                        <label>Contact Full Name</label>
                                        <div className="form_group_input">
                                            <input
                                                type="text"
                                                name="contactFullName"
                                                id="contactFullName"
                                                value={this.state.contactFullName}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('contact Full Name', this.state.contactFullName, 'required')}</span>
                                        </div>
                                    </div>
                                    {/* <div className="form_group">
                                        <label>City</label>
                                        <div className="form_group_input">
                                            <input
                                                type="text"
                                                name="city"
                                                id="city"
                                                value={this.state.city}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('city', this.state.city, 'required')}</span>
                                        </div>
                                    </div> */}
                                    {/* <div className="form_group">
                                        <label>State</label>
                                        <div className="form_group_input">
                                            <input
                                                type="text"
                                                name="state"
                                                id="state"
                                                value={this.state.state}
                                                onChange={this.onInputChange}
                                                autoComplete="off"
                                            />
                                            <span style={{ color: 'red' }}>{this.validator.message('state', this.state.state, 'required')}</span>
                                        </div>
                                    </div> */}

                                </div>
                                <div className="btn_wrapper">
                                    <button className="grayBTN"
                                        type="button"
                                        onClick={() => this.clearFn()}
                                    >Clear</button>
                                    <button className="orangeBTN"
                                        type="button"
                                        disabled={this.state.imagePreloader ? true : false}
                                        onClick={(e) => this.submitFn(e)}
                                    >Submit</button>
                                </div>
                            </form>
                        </div>
                        : ''}
                </div>

                {/* Loader */}
                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                        ""
                    )}

                {this.state.deleteImagePopup ? (
                    <PopUpCustomAll
                        HeaderName="Delete Image?"
                        insideDetails="Are You Sure ?"
                        insideData="You want to delete this image"
                        popupState={this.closeAdminUser}
                        yesPopUp={this.deleteImagePopup}
                    />
                ) : (
                        ""
                    )}

                {this.state.errorPopup ? (
                    <ErrorPopUp
                        errorMsg={this.state.errorMsg}
                        errorMsgPopup={this.validateModel}
                    />
                ) : (
                        ""
                    )}

                {/* For resend Mail */}
                <div className={`user_popup ${this.state.resendMailPopup ? "active" : ''}`}>
                    <span className="popup_overlay" onClick={this.closePartnerUser}></span>
                    <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
                        <div className="approve_popup_header text_center relative">
                            <p>Do you want to send the invitation email to {this.state.userContactFullName} again?</p>
                            <span className="close_popup" onClick={this.closePartnerUser}>
                                <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.192 0.343994L5.94897 4.58599L1.70697 0.343994L0.292969 1.75799L4.53497 5.99999L0.292969 10.242L1.70697 11.656L5.94897 7.41399L10.192 11.656L11.606 10.242L7.36397 5.99999L11.606 1.75799L10.192 0.343994Z" fill="black" />
                                </svg>
                            </span>
                        </div>
                        <div className="content">
                            <div className="field_row text_center">
                                <button className="" onClick={this.closePartnerUser}>OK</button>
                                <button className="active" onClick={this.resendMail}>YES {this.state.emailLoader &&
                                    <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                }</button>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>


        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(satellitesViewEvent) 